// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-IntegrationPanel-module__integrationPanel-JAIy7 {
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 48px;
  height: 100px;
  width: -moz-fit-content;
  width: fit-content;
}

@keyframes nightbot-IntegrationPanel-module__gradientShift-gA5Kn {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

.nightbot-IntegrationPanel-module__integrationPanelContainer-A5eb1 {
  position: absolute;
  width: calc(100% - 8px);
  height: 100%;
  overflow: hidden;
}

.nightbot-IntegrationPanel-module__integrationPanelAnimation-OeGLg::before {
  content: '';
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  width: 100%;
  bottom: 0;
  z-index: -1;
  height: 20px;
  animation: nightbot-IntegrationPanel-module__gradientShift-gA5Kn 1.5s ease infinite;
  animation-fill-mode: forwards;
  background: linear-gradient(to right, transparent, var(--mantine-color-green-3) 40%, var(--mantine-color-green-1) 50%, var(--mantine-color-green-3) 60%, transparent);
}

.nightbot-IntegrationPanel-module__logo-Mry8l {
  width: 64px;
  height: 64px;
  padding: 16px;
  color: var(--mantine-color-indigo-0);
  border-radius: var(--mantine-radius-xl);
  background-color: var(--mantine-color-indigo-7);
}

@supports ((-webkit-mask-image: paint(squircle)) or (mask-image: paint(squircle))) {

.nightbot-IntegrationPanel-module__logo-Mry8l {
    --squircle-smooth: 1;
    --squircle-radius: 96px;
    -webkit-mask-image: paint(squircle);
            mask-image: paint(squircle);
}
  }

.nightbot-IntegrationPanel-module__platformIcon-OApES,
.nightbot-IntegrationPanel-module__providerIcon-KdU8D {
  width: 48px;
  height: 48px;
  border-radius: var(--mantine-radius-lg);
  background-color: var(--mantine-color-gray-1);
  color: var(--mantine-color-gray-0);
  display: grid;
  align-items: center;
  justify-items: center;
  place-items: center;
}

@supports ((-webkit-mask-image: paint(squircle)) or (mask-image: paint(squircle))) {

.nightbot-IntegrationPanel-module__platformIcon-OApES,
.nightbot-IntegrationPanel-module__providerIcon-KdU8D {
    --squircle-smooth: 1;
    --squircle-radius: 96px;
    -webkit-mask-image: paint(squircle);
            mask-image: paint(squircle);
}
  }

.nightbot-IntegrationPanel-module__providerIcon-KdU8D {
  background-color: var(--mantine-color-gray-1);
}

.nightbot-IntegrationPanel-module__discordIcon-H7kah {
  background-color: var(--color-discord-blurple);
}

.nightbot-IntegrationPanel-module__youtubeIcon-NrFYj {
  color: var(--mantine-color-red-7);
  background-color: white;
}

.nightbot-IntegrationPanel-module__noiceIcon-QISDo {
  background-color: var(--mantine-color-purple-9);
}

.nightbot-IntegrationPanel-module__twitchIconContainer-JqRoD {
  background-color: var(--mantine-color-purple-6);
  color: var(--mantine-color-purple-0);
}

.nightbot-IntegrationPanel-module__twitchIcon-m1ao8 {
  width: 24px;
  height: 24px;
}

.nightbot-IntegrationPanel-module__trovoIconContainer-FWRVR {
  background-color: var(--color-trovo-green);
  color: white;
}

.nightbot-IntegrationPanel-module__trovoLogo-LVCri {
  width: 28px;
  height: 28px;
}

.nightbot-IntegrationPanel-module__soopIconContainer-sAKAG {
  background-color: var(--mantine-color-gray-10);
  color: #d1ff00;
}

.nightbot-IntegrationPanel-module__soopLogo-yjUQ8 {
  width: 32px;
  height: 32px;
}

.nightbot-IntegrationPanel-module__twitchIconContainer-JqRoD {
  padding: 4px;
}

.nightbot-IntegrationPanel-module__providerIconContainer-LJt0i {
  background-color: var(--mantine-color-gray-3);
  color: var(--mantine-color-indigo-8);
}

.nightbot-IntegrationPanel-module__shieldIcon-r_csk,
.nightbot-IntegrationPanel-module__wandIcon-yKHl9,
.nightbot-IntegrationPanel-module__userClockIcon-F7nFF,
.nightbot-IntegrationPanel-module__bullhornIcon-vxfdt {
  width: 24px;
  height: 24px;
}

.nightbot-IntegrationPanel-module__noiceLogo-ujJPi {
  width: 100%;
  height: 100%;
  padding: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/landing/IntegrationPanel.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,OAAO;EACP,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mFAA2C;EAC3C,6BAA6B;EAC7B,qKAAqK;AACvK;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,uCAAuC;EACvC,+CAA+C;AAOjD;;AALE;;AARF;IASI,oBAAoB;IACpB,uBAAuB;IACvB,mCAA2B;YAA3B,2BAA2B;AAE/B;EADE;;AAGF;;EAEE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,6CAA6C;EAC7C,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EAAnB,qBAAmB;EAAnB,mBAAmB;AAOrB;;AALE;;AAVF;;IAWI,oBAAoB;IACpB,uBAAuB;IACvB,mCAA2B;YAA3B,2BAA2B;AAE/B;EADE;;AAGF;EACE,6CAA6C;AAC/C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;EAC/C,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;;;;EAIE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd","sourcesContent":[".integrationPanel {\n  position: relative;\n  z-index: 10;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 48px;\n  height: 100px;\n  width: fit-content;\n}\n\n@keyframes gradientShift {\n  0% {\n    left: -100%;\n  }\n  100% {\n    left: 100%;\n  }\n}\n\n.integrationPanelContainer {\n  position: absolute;\n  width: calc(100% - 8px);\n  height: 100%;\n  overflow: hidden;\n}\n\n.integrationPanelAnimation::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 0;\n  width: 100%;\n  bottom: 0;\n  z-index: -1;\n  height: 20px;\n  animation: gradientShift 1.5s ease infinite;\n  animation-fill-mode: forwards;\n  background: linear-gradient(to right, transparent, var(--mantine-color-green-3) 40%, var(--mantine-color-green-1) 50%, var(--mantine-color-green-3) 60%, transparent);\n}\n\n.logo {\n  width: 64px;\n  height: 64px;\n  padding: 16px;\n  color: var(--mantine-color-indigo-0);\n  border-radius: var(--mantine-radius-xl);\n  background-color: var(--mantine-color-indigo-7);\n\n  @supports (mask-image: paint(squircle)) {\n    --squircle-smooth: 1;\n    --squircle-radius: 96px;\n    mask-image: paint(squircle);\n  }\n}\n\n.platformIcon,\n.providerIcon {\n  width: 48px;\n  height: 48px;\n  border-radius: var(--mantine-radius-lg);\n  background-color: var(--mantine-color-gray-1);\n  color: var(--mantine-color-gray-0);\n  display: grid;\n  place-items: center;\n\n  @supports (mask-image: paint(squircle)) {\n    --squircle-smooth: 1;\n    --squircle-radius: 96px;\n    mask-image: paint(squircle);\n  }\n}\n\n.providerIcon {\n  background-color: var(--mantine-color-gray-1);\n}\n\n.discordIcon {\n  background-color: var(--color-discord-blurple);\n}\n\n.youtubeIcon {\n  color: var(--mantine-color-red-7);\n  background-color: white;\n}\n\n.noiceIcon {\n  background-color: var(--mantine-color-purple-9);\n}\n\n.twitchIconContainer {\n  background-color: var(--mantine-color-purple-6);\n  color: var(--mantine-color-purple-0);\n}\n\n.twitchIcon {\n  width: 24px;\n  height: 24px;\n}\n\n.trovoIconContainer {\n  background-color: var(--color-trovo-green);\n  color: white;\n}\n\n.trovoLogo {\n  width: 28px;\n  height: 28px;\n}\n\n.soopIconContainer {\n  background-color: var(--mantine-color-gray-10);\n  color: #d1ff00;\n}\n\n.soopLogo {\n  width: 32px;\n  height: 32px;\n}\n\n.twitchIconContainer {\n  padding: 4px;\n}\n\n.providerIconContainer {\n  background-color: var(--mantine-color-gray-3);\n  color: var(--mantine-color-indigo-8);\n}\n\n.shieldIcon,\n.wandIcon,\n.userClockIcon,\n.bullhornIcon {\n  width: 24px;\n  height: 24px;\n}\n\n.noiceLogo {\n  width: 100%;\n  height: 100%;\n  padding: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"integrationPanel": `nightbot-IntegrationPanel-module__integrationPanel-JAIy7`,
	"integrationPanelContainer": `nightbot-IntegrationPanel-module__integrationPanelContainer-A5eb1`,
	"integrationPanelAnimation": `nightbot-IntegrationPanel-module__integrationPanelAnimation-OeGLg`,
	"gradientShift": `nightbot-IntegrationPanel-module__gradientShift-gA5Kn`,
	"logo": `nightbot-IntegrationPanel-module__logo-Mry8l`,
	"platformIcon": `nightbot-IntegrationPanel-module__platformIcon-OApES`,
	"providerIcon": `nightbot-IntegrationPanel-module__providerIcon-KdU8D`,
	"discordIcon": `nightbot-IntegrationPanel-module__discordIcon-H7kah`,
	"youtubeIcon": `nightbot-IntegrationPanel-module__youtubeIcon-NrFYj`,
	"noiceIcon": `nightbot-IntegrationPanel-module__noiceIcon-QISDo`,
	"twitchIconContainer": `nightbot-IntegrationPanel-module__twitchIconContainer-JqRoD`,
	"twitchIcon": `nightbot-IntegrationPanel-module__twitchIcon-m1ao8`,
	"trovoIconContainer": `nightbot-IntegrationPanel-module__trovoIconContainer-FWRVR`,
	"trovoLogo": `nightbot-IntegrationPanel-module__trovoLogo-LVCri`,
	"soopIconContainer": `nightbot-IntegrationPanel-module__soopIconContainer-sAKAG`,
	"soopLogo": `nightbot-IntegrationPanel-module__soopLogo-yjUQ8`,
	"providerIconContainer": `nightbot-IntegrationPanel-module__providerIconContainer-LJt0i`,
	"shieldIcon": `nightbot-IntegrationPanel-module__shieldIcon-r_csk`,
	"wandIcon": `nightbot-IntegrationPanel-module__wandIcon-yKHl9`,
	"userClockIcon": `nightbot-IntegrationPanel-module__userClockIcon-F7nFF`,
	"bullhornIcon": `nightbot-IntegrationPanel-module__bullhornIcon-vxfdt`,
	"noiceLogo": `nightbot-IntegrationPanel-module__noiceLogo-ujJPi`
};
export default ___CSS_LOADER_EXPORT___;
